import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";

const PickupPointSelect = ({ onPickupPointChange, disabled, sx }) => {
  const [pickupPoint, setPickupPoint] = useState("");
  const handleChange = (e) => {
    const value = e.target.value;
    setPickupPoint(value);
    onPickupPointChange(value);
  };

  const sxArray = Array.isArray(sx) ? sx : sx ? [sx] : [];
  const baseSx = {
    backgroundColor: "rgba(245, 255, 245, 0.06)",
    borderRadius: "18px",
    transition: "background-color 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
      backgroundColor: "rgba(245, 255, 245, 0.1)",
    },
    "& .MuiOutlinedInput-root": {
      color: "#F5FFF5",
      "& fieldset": {
        borderColor: "rgba(245, 255, 245, 0.35)",
      },
      "&:hover fieldset": {
        borderColor: "#B8FFDA",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#B8FFDA",
        boxShadow: "0 0 0 2px rgba(184, 255, 218, 0.25)",
      },
      "&.Mui-disabled fieldset": {
        borderColor: "rgba(245, 255, 245, 0.2)",
      },
    },
    "& .MuiSelect-select": {
      color: "#F5FFF5",
      paddingTop: "14px",
      paddingBottom: "14px",
      fontWeight: 500,
    },
    "& .MuiSvgIcon-root": {
      color: "#B8FFDA",
    },
    "& .MuiInputLabel-root": {
      color: "rgba(245, 255, 245, 0.85)",
      fontWeight: 600,
      letterSpacing: "0.02em",
      "&.Mui-focused": {
        color: "#B8FFDA",
      },
      "&.Mui-disabled": {
        color: "rgba(245, 255, 245, 0.55)",
      },
    },
    "& .MuiFormHelperText-root": {
      color: "rgba(245, 255, 245, 0.75)",
      marginLeft: 0,
      marginRight: 0,
    },
  };
  const combinedSx = [baseSx, ...sxArray];

  return (
    <TextField
      select
      required
      disabled={disabled}
      onChange={handleChange}
      label="Select Pickup Point"
      variant="outlined"
      value={pickupPoint}
      InputLabelProps={{
        shrink: true,
      }}
      SelectProps={{
        displayEmpty: true,
        renderValue: (value) =>
          value ? (
            value
          ) : (
            <span className="booking-select-placeholder">Choose a pickup hub</span>
          ),
        MenuProps: {
          PaperProps: {
            sx: {
              backgroundColor: "rgba(10, 36, 18, 0.96)",
              color: "#F5FFF5",
              "& .MuiMenuItem-root.Mui-selected": {
                backgroundColor: "rgba(142, 255, 185, 0.18)",
              },
              "& .MuiMenuItem-root:hover": {
                backgroundColor: "rgba(142, 255, 185, 0.12)",
              },
            },
          },
        },
      }}
      fullWidth
      helperText="We recommend arriving 15 minutes early at your selected hub."
      FormHelperTextProps={{
        sx: {
          color: "rgba(245, 255, 245, 0.75)",
          marginLeft: 0,
          marginRight: 0,
        },
      }}
      sx={combinedSx}
    >
      <MenuItem disabled value="">
        <span className="booking-select-placeholder">Choose a pickup hub</span>
      </MenuItem>
      <MenuItem value="Anderson Gate">Anderson Gate</MenuItem>
      <MenuItem value="King Nehale Gate">King Nehale Gate</MenuItem>
      <MenuItem value="Von Lindequist Gate">Von Lindequist Gate</MenuItem>
      <MenuItem value="Outjo">Outjo</MenuItem>
      <MenuItem value="Etosha Trading Post">Etosha Trading Post</MenuItem>
      <MenuItem value="Etosha Safari Camp">Etosha Safari Camp</MenuItem>
    </TextField>
  );
};

export default PickupPointSelect;
